import { useState, useEffect } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase.js";
import { useAuth } from "../../useAuth.js";
import "./users.css";

function Users() {
  const { user, loading: authLoading } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user || authLoading) {
      return;
    }

    const usersRef = collection(db, "Users");
    
    const unsubscribe = onSnapshot(usersRef, (querySnapshot) => {
      try {
        const usersList = [];
        querySnapshot.forEach((doc) => {
          const userData = doc.data();
          usersList.push({
            id: doc.id,
            ...userData
          });
        });

        setUsers(usersList);
        setLoading(false);
        setError(null);
      } catch (err) {
        console.error("Error processing users:", err);
        setError("Failed to process users. Please refresh the page.");
        setLoading(false);
      }
    }, (err) => {
      console.error("Error listening to users:", err);
      setError("Failed to connect to users. Please check your connection.");
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user, authLoading]);

  if (authLoading) {
    return (
      <div className="users-page-container">
        <div className="users-page-loading-container">
          <div className="users-page-loading-spinner"></div>
          <p>Authenticating...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="users-page-container">
        <div className="users-page-auth-error">
          <h2>Access Denied</h2>
          <p>You must be logged in to access the Users page.</p>
          <p>Please log in and try again.</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="users-page-container">
        <div className="users-page-loading-container">
          <div className="users-page-loading-spinner"></div>
          <p>Loading users...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="users-page-container">
        <div className="users-page-error-message">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="users-page-container">
      <div className="users-page-header">
        <h1>Users</h1>
        <p>Manage user accounts and permissions</p>
      </div>

      <div className="users-page-list">
        {users.length === 0 ? (
          <div className="users-page-no-users">
            <h3>No users found</h3>
            <p>There are no users in the system yet.</p>
          </div>
        ) : (
          users.map((user) => (
            <div key={user.id} className="users-page-card">
              <div className="users-page-info">
                <div className="users-page-name">{user.name || 'Unknown User'}</div>
                <div className="users-page-details">
                  <div className="users-page-email">{user.email}</div>
                  <div className="users-page-role">{user.role || 'User'}</div>
                  <div className="users-page-position">{user.position || 'N/A'}</div>
                </div>
              </div>
              <div className="users-page-status">
                <span className={`users-page-status-badge ${user.active ? 'active' : 'inactive'}`}>
                  {user.active ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Users;
